<template>
	<div>
		<BarGraphVertical :data="upperData" :types="types" />
		<BarGraphVertical :data="lowerData" :types="types" :negative="true" />
	</div>
</template>

<script>
import BarGraphVertical from "./BarGraphVertical";

export default {
	props: {
		data: Array,
		types: Array
	},
	components: {
		BarGraphVertical
	},
	computed: {
		upperData: function() {
			return this.data.map(item => ({
				name: item.name,
				values: item.values.map(i => i[1])
			}));
		},
		lowerData: function() {
			return this.data.map(item => ({
				name: item.name,
				values: item.values.map(i => i[0])
			}));
		}
	}
};
</script>
